import React, { useState } from 'react';
import { useNavigate } from "react-router-dom";
import { AppBar, Toolbar, Button, Box, MenuItem, Menu, Typography, IconButton, Tooltip, Avatar, Container, Grid, Stack, Divider, useTheme, useMediaQuery, ButtonGroup, Collapse, CircularProgress, Radio, RadioGroup } from "@mui/material"
import { Link } from 'react-router-dom';
import Link_Icon_White from '../Assets/Link_Icon_White.png'
// import Parcel_Icon_Online from '../Assets/Parcel_Icon_Online.png';
// import Pallet_Icon_Online from '../Assets/Pallet_Icon_Online.png'
import Settings_Icon from '../Assets/Settings_Icon.png'
import Support_Icon from '../Assets/Support_Icon.png'
import Calibrate_Icon from '../Assets/Calibrate_1_Icon.png'
import Info_Icon from '../Assets/Info_Icon.png'
import MenuIcon from '@mui/icons-material/Menu';
import LogoutIcon from '@mui/icons-material/Logout';
import PersonIcon from '@mui/icons-material/Person';
import RefreshIcon from '@mui/icons-material/Refresh';
import Drawer from '@mui/material/Drawer';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import { Machine } from '../ts/Connections';
import { useLocation } from 'react-router-dom';
import { ExpandLess, ExpandMore } from '@mui/icons-material';
import { useMsal } from '@azure/msal-react';
import LanguageSwitcher from './LanguageSwitcher/LanguageSwitcher';
import { useTranslation } from 'react-i18next';
import DarkModeIcon from '@mui/icons-material/DarkMode';
import LightModeIcon from '@mui/icons-material/LightMode';
import BrightnessAutoIcon from '@mui/icons-material/BrightnessAuto';
import PaletteOutlinedIcon from '@mui/icons-material/PaletteOutlined';
import { useThemeMode } from '../ThemeContext';

const UPDATE_REQUIRED = import.meta.env.VITE_UPDATE_REQUIRED
const pages = ["Matchmaking"]
const DEV_MODE = import.meta.env.VITE_DEV_ENVIRONMENT || false;
const DOMAIN = import.meta.env.VITE_DOMAIN || '.spectre-licensing.com'

export const Navbar = (props: any) => {
    const { setIsLoggedIn, removeCookie, window, setShowCalibration, setShowMachineSettings, setShowSupport, setShowCertification, selectedMachine, setSelectedMachine, onlineMachines, setMachineEvents, mobileNavbarOpen, setMobileNavbarOpen, refreshMatchmaking, isRefreshingMatchmaking, setSettingsLoaded, user } = props
    const [anchorElUser, setAnchorElUser] = React.useState<null | HTMLElement>(null);
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
    const open = Boolean(anchorEl);
    const [isOpen, setIsOpen] = useState<boolean>(false);
    const [appearanceOpen, setAppearanceOpen] = useState<boolean>(false);
    // Memoized sorted list of online machines to avoid duplicating sort logic in multiple render paths
    const sortedOnlineMachines: Machine[] = React.useMemo(() => {
        if (!Array.isArray(onlineMachines)) return [];
        return [...onlineMachines].sort((a: Machine, b: Machine) => {
            const aOutdated = a.isOutdated ?? false;
            const bOutdated = b.isOutdated ?? false;
            if (aOutdated !== bOutdated) return aOutdated ? 1 : -1; // outdated last
            // Case-insensitive, numeric-aware alphabetical compare
            return a.machineName.localeCompare(b.machineName, undefined, { sensitivity: 'base', numeric: true });
        });
    }, [onlineMachines]);
    // SSO sign in validation logic
    const { accounts, instance } = useMsal();
    const activeAccount = accounts.find((account) => account.homeAccountId === accounts[0].homeAccountId);
    const { t } = useTranslation(); // Add useTranslation hook
    const { preference, setPreference } = useThemeMode();

    const handleLogoutRedirect = () => {
        instance.logoutRedirect().catch((error) => console.log(error));
    };

    const navigate = useNavigate();

    const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    // useEffect(() => {
    //     selectedMachine.scanMode === 2 ? setMachineIcon(Parcel_Icon_Online) : setMachineIcon(Pallet_Icon_Online)
    // }, [selectedMachine])

    const handleDrawerToggle = () => {
        setMobileNavbarOpen((prevState: boolean) => !prevState);
    };

    const handleOpenUserMenu = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorElUser(event.currentTarget);
    };

    const handleCloseUserMenu = () => {
        setAnchorElUser(null);
    };

    const location = useLocation();
    const isControlRoute = location.pathname.startsWith('/matchmaking/control/');

    const drawerWidth = 240;

    //https://mui.com/material-ui/react-app-bar/#fixed-placement;
    const container = window !== undefined ? () => window().document.body : undefined;

    // for dev_mode and displaying current window size
    const theme = useTheme();

    const isSm = useMediaQuery(theme.breakpoints.only('sm'));
    const isMd = useMediaQuery(theme.breakpoints.only('md'));
    const isLg = useMediaQuery(theme.breakpoints.only('lg'));
    const isXl = useMediaQuery(theme.breakpoints.only('xl'));

    let breakpointText = 'xs';

    if (isSm) {
        breakpointText = 'sm';
    } else if (isMd) {
        breakpointText = 'md';
    } else if (isLg) {
        breakpointText = 'lg';
    } else if (isXl) {
        breakpointText = 'xl';
    }

    const styles = {

        NavtabButton: {
            height: 64,
            width: 125,
            color: theme.palette.spectre.textPrimary,
            boxShadow: 0,
            backgroundColor: theme.palette.spectre.page,
            '&:hover': {
                backgroundColor: theme.palette.spectre.surfaceMuted,
            },
            '&:select': {
                backgroundColor: theme.palette.spectre.surfaceMuted,
            },
            borderRadius: 0,
            borderRight: '2px solid',
            borderLeft: {
                xs: '2px solid',
                md: 'none'
            },
            borderColor: {
                xs: theme.palette.spectre.border,
                md: 'none'
            },
        },
        buttonText: {
            fontSize: 15,
            fontWeight: 500,
            color: 'white'
        },
        Navtabselected: {
            height: 64,
            width: 125,
            borderRadius: 0,
            color: "error.main",
            backgroundColor: "secondary.main",
        },
        Navbar: {
            borderRadius: 0,
            elevation: 0,
        },
        Logoff: {
            float: 'right'
        },
        devMode: {
            color: theme.palette.spectre.textPrimary,
            fontWeight: 700,
            backgroundColor: "#F48430",
            fontSize: {
                xs: 10,
                sm: 12,
                md: 14
            },
            px: {
                xs: 0.5,
                sm: 1
            },
            borderRadius: 1,
            display: 'flex',
            alignItems: 'center',
            gap: 0.5,
            whiteSpace: 'nowrap'
        },
        drawer: {
            backgroundColor: theme.palette.spectre.navigation,
        },
        menuListItem: {
            textAlign: 'center',
            color: '#FFFFFF',
            '&:hover': {
                backgroundColor: theme.palette.spectre.navigationHover,
            },
        },
        divider: {
            backgroundColor: '#FFFFFF'
        },
        buttonIcons: {
            height: 22,
        },
        buttonIconsNavBar: {
            height: 15,
            mr: 1
        },
        navButton: {
            color: "#FFFFFF",
            backgroundColor: theme.palette.spectre.navigationHover,
            '&:hover': {
                backgroundColor: theme.palette.spectre.navigationHover,
            },
        },
        imageBox: {
            height: 40,
        },
        // icon: {
        //     parcel_online: Parcel_Icon_Online,
        //     pallet_online: Pallet_Icon_Online,
        //     empty: ""
        // },
        mySpectresLarge: {
            display: {
                lg: 'block',
                xs: 'none'
            },
        }
    }

    const controlButtons = (
        <React.Fragment>
            <ListItem sx={{
                textAlign: 'center',
                color: '#FFFFFF',
            }}>
                <ListItemText primary={selectedMachine ? selectedMachine.machineName : ""} />
            </ListItem>
            <Divider sx={styles.divider}></Divider>
            <ListItem disablePadding>
                <ListItemButton sx={styles.menuListItem} onClick={() => { setShowCalibration(true) }}>
                    <ListItemIcon>
                        <Box
                            component="img"
                            sx={styles.buttonIcons}
                            alt="Calibrate icon"
                            src={Calibrate_Icon}
                        />
                    </ListItemIcon>
                    <ListItemText primary={t('navBar.navigationButtons.calibrate')} />
                </ListItemButton>
            </ListItem>
            <ListItem disablePadding>
                <ListItemButton sx={styles.menuListItem} onClick={() => { setShowMachineSettings(true) }}>
                    <ListItemIcon>
                        <Box
                            component="img"
                            sx={styles.buttonIcons}
                            alt="Settings icon"
                            src={Settings_Icon}
                        />
                    </ListItemIcon>
                    <ListItemText primary={t('navBar.navigationButtons.settings')} />
                </ListItemButton>
            </ListItem>
            <ListItem disablePadding>
                <ListItemButton sx={styles.menuListItem} onClick={() => { setShowSupport(true) }}>
                    <ListItemIcon>
                        <Box
                            component="img"
                            sx={styles.buttonIcons}
                            alt="Support icon"
                            src={Support_Icon}
                        />
                    </ListItemIcon>
                    <ListItemText primary={t('navBar.navigationButtons.support')} />
                </ListItemButton>
            </ListItem>
            <ListItem disablePadding>
                <ListItemButton sx={styles.menuListItem} onClick={() => { setShowCertification(true) }}>
                    <ListItemIcon>
                        <Box
                            component="img"
                            sx={styles.buttonIcons}
                            alt="Info icon"
                            src={Info_Icon}
                        />
                    </ListItemIcon>
                    <ListItemText primary={t('navBar.navigationButtons.machineInfo')} />
                </ListItemButton>
            </ListItem>
            <Divider sx={styles.divider}></Divider>
        </React.Fragment>
    )

    const userIcon = (
        <React.Fragment >
            <Tooltip title={t('navBar.navigationButtons.openUserSettings')}>
                <IconButton onClick={handleOpenUserMenu} sx={{ p: 1 }}>
                    <Avatar>
                        <PersonIcon />
                    </Avatar>
                </IconButton>
            </Tooltip>
            <Menu
                sx={{ mt: '45px' }}
                id="menu-appbar"
                anchorEl={anchorElUser}
                anchorOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                }}
                keepMounted
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                }}
                open={Boolean(anchorElUser)}
                onClose={handleCloseUserMenu}
            >
                <MenuItem
                    onClick={() => {}}
                    sx={{
                        display: 'flex',
                        alignItems: 'center',
                        minHeight: '48px',
                        cursor: 'default',
                        '&:hover': {
                            backgroundColor: 'transparent'
                        }
                    }}
                >
                    <ListItemIcon sx={{ minWidth: '36px' }}>
                        <PersonIcon fontSize="small" />
                    </ListItemIcon>
                    <Typography sx={{ fontWeight: 500 }} noWrap title={user}>{user ?? 'Unknown user'}</Typography>
                </MenuItem>
                <Divider />
                <MenuItem
                    onClick={() => {
                        if (activeAccount) {
                            // User is signed in via SSO
                            handleLogoutRedirect();
                        } else {
                            // User is signed in via Licensing
                            removeCookie('user64', { path: '/', domain: DOMAIN })
                            setIsLoggedIn(false)
                            navigate('/AuthRedirectLogOut')
                        }
                    }}
                    sx={{
                        display: 'flex',
                        alignItems: 'center',
                        minHeight: '48px' // Ensuring consistent height
                    }}
                >
                    <ListItemIcon sx={{ minWidth: '36px' }}>
                        <LogoutIcon fontSize="small" />
                    </ListItemIcon>
                    <Typography sx={{ fontWeight: 500 }}>{t('navBar.navigationButtons.logout')}</Typography>
                </MenuItem>
                <Box sx={{ width: '100%' }}>
                    <LanguageSwitcher closeParentMenu={handleCloseUserMenu} />
                </Box>
                <ListItemButton
                    onClick={() => setAppearanceOpen(!appearanceOpen)}
                    sx={{ minHeight: '48px', px: 2, display: 'flex', alignItems: 'center' }}
                >
                    <ListItemIcon sx={{ minWidth: '36px' }}>
                        <PaletteOutlinedIcon fontSize="small" />
                    </ListItemIcon>
                    <ListItemText
                        primary={t('navBar.navigationButtons.appearance')}
                        primaryTypographyProps={{ sx: { fontWeight: 500 } }}
                    />
                    {appearanceOpen ? <ExpandLess /> : <ExpandMore />}
                </ListItemButton>
                <Collapse in={appearanceOpen} timeout="auto" unmountOnExit>
                    <List component="div" disablePadding>
                        <RadioGroup
                            aria-label={String(t('navBar.navigationButtons.appearance'))}
                            name="theme-preference"
                            value={preference}
                            onChange={(event) => setPreference(event.target.value as 'light' | 'dark' | 'system')}
                        >
                            {[
                                { value: 'light', label: t('navBar.navigationButtons.light'), icon: <LightModeIcon fontSize="small" /> },
                                { value: 'dark', label: t('navBar.navigationButtons.dark'), icon: <DarkModeIcon fontSize="small" /> },
                                { value: 'system', label: t('navBar.navigationButtons.system'), icon: <BrightnessAutoIcon fontSize="small" /> },
                            ].map((option) => (
                                <ListItemButton
                                    key={option.value}
                                    selected={preference === option.value}
                                    onClick={() => setPreference(option.value as 'light' | 'dark' | 'system')}
                                    sx={{ minHeight: '40px', pl: 4 }}
                                >
                                    <Radio size="small" value={option.value} inputProps={{ 'aria-label': option.label }} />
                                    <ListItemIcon sx={{ minWidth: '30px' }}>
                                        {option.icon}
                                    </ListItemIcon>
                                    <ListItemText primary={option.label} />
                                </ListItemButton>
                            ))}
                        </RadioGroup>
                    </List>
                </Collapse>
            </Menu>
        </React.Fragment>
    )

    const mySpectresDrawer = (
        <>
            <ListItem disablePadding disableGutters>
                <ListItemButton
                    sx={styles.menuListItem}
                    onClick={() => setIsOpen(!isOpen)}
                >
                    <ListItemText primary={t('navBar.navigationButtons.mySpectres')} sx={{ pl: 3 }} />
                    <ExpandMore sx={{ transform: isOpen ? 'rotate(180deg)' : 'rotate(0deg)', transition: 'transform 0.3s' }} />
                </ListItemButton>
            </ListItem>
            <Collapse in={isOpen} timeout="auto" unmountOnExit>
                <Divider sx={styles.divider} />
                <ListItem disablePadding>
                    <ListItemButton
                        sx={{
                            ...styles.menuListItem,
                            display: 'flex',
                            justifyContent: 'center'
                        }}
                        disabled={!!isRefreshingMatchmaking}
                        onClick={async () => {
                            if (typeof refreshMatchmaking === 'function') {
                                try { await refreshMatchmaking(); } catch { }
                            }
                        }}
                    >
                        <RefreshIcon fontSize="small" sx={{ mr: 1 }} />
                        <ListItemText
                            primary={t('navBar.navigationButtons.refreshList')}
                            sx={{ flex: '0 0 auto', pr: 2 }}
                        />
                        {isRefreshingMatchmaking && (
                            <CircularProgress size={18} sx={{ color: '#FFFFFF', ml: 1 }} />
                        )}
                    </ListItemButton>
                </ListItem>
                <Divider sx={styles.divider} />
                <ListItem disablePadding>
                    <ListItemButton sx={styles.menuListItem} component={Link} to={`/${pages[0]}`} onClick={() => {
                        handleDrawerToggle();
                        setIsOpen(!isOpen);
                    }}>
                        <ListItemText primary={"View all"} />
                    </ListItemButton>
                </ListItem>

                    {sortedOnlineMachines
                        .map((machine: Machine, index: number) => {
                            return (
                                <ListItem
                                    disablePadding
                                    key={index}
                                    component={machine.isOutdated ? 'div' : Link}
                                    to={machine.isOutdated ? undefined : `/matchmaking/control/${encodeURIComponent(machine.machineName)}`}
                                    onClick={() => {
                                        if (machine.isOutdated) {
                                            return;
                                        }
                                        if (onlineMachines[index]?.connection?.ping) {
                                            onlineMachines[index].connection.ping()
                                                .then((response: boolean) => {
                                                    if (!response) {
                                                        alert(`Failed to connect to ${onlineMachines[index].machineName}, please refresh the list and try again.`);
                                                    } else {
                                                        setSettingsLoaded(false);
                                                        setSelectedMachine(machine);
                                                        setMachineEvents([]);
                                                    }
                                                })
                                                .catch((err: any) => {
                                                    console.error("Error pinging machine:", err);
                                                    alert(`Failed to connect to ${onlineMachines[index].machineName}, please refresh the list and try again.`);
                                                });
                                        } else {
                                            alert(`Connection not available for ${onlineMachines[index]?.machineName || 'this machine'}, please try refreshing the machine list.`);
                                        }
                                        handleDrawerToggle();
                                        setIsOpen(!isOpen);
                                    }}
                                >
                                    <ListItemButton
                                        sx={{
                                            ...styles.menuListItem,
                                            textAlign: 'center',
                                            justifyContent: 'center',
                                            opacity: (machine.isOutdated || machine.machineName === selectedMachine?.machineName) ? 0.5 : 1,
                                            cursor: (machine.isOutdated || machine.machineName === selectedMachine?.machineName) ? 'not-allowed' : 'pointer'
                                        }}
                                        disabled={machine.isOutdated || machine.machineName === selectedMachine?.machineName}
                                    >
                                        <ListItemText
                                            primary={machine.machineName + (machine.isOutdated ? ` (Update Required)` : '')}
                                            sx={{ textAlign: 'center' }}
                                        />
                                    </ListItemButton>
                                </ListItem>
                            );
                        })}
            </Collapse>
        </>
    );

    const drawer = (
        <Box sx={{ textAlign: 'center' }}>
            {userIcon}
            <List onClick={handleDrawerToggle} sx={{ padding: 0, margin: 0 }}>
                {isControlRoute ? controlButtons : ''}
            </List>
            <List sx={{ padding: 0, margin: 0 }}>
                {isControlRoute ? mySpectresDrawer : ''}
            </List>
        </Box>
    );

    return (
        <>
            <AppBar elevation={0} position="fixed">
                <Container maxWidth={false}>
                    <Toolbar disableGutters sx={{ justifyContent: 'space-between' }}>
                        <Grid container
                            direction="row"
                            justifyContent="space-between"
                            alignItems="center">
                            <Grid container item md={6} sm={6} xs={6}
                                direction="row"
                                justifyContent="space-between"
                                alignItems="center">
                                {/* Clickable logo linking back to /login */}
                                <Box component={Link} to="/login" sx={{ display: 'inline-flex', alignItems: 'center', textDecoration: 'none' }} aria-label="Go to login page">
                                    <Box
                                        component="img"
                                        sx={{
                                            height: 50,
                                            cursor: 'pointer'
                                        }}
                                        alt="Spectre Link logo"
                                        src={Link_Icon_White}
                                    />
                                </Box>
                                {DEV_MODE ? (
                                    <Typography sx={styles.devMode}>
                                        {`${breakpointText} | `}
                                        <Box component="span" sx={{ display: { xs: 'none', sm: 'inline' } }}>conn: </Box>
                                        {selectedMachine?.connection ? selectedMachine.connection.type() : ''}
                                    </Typography>
                                ) : <></>}
                                {
                                    selectedMachine
                                        ?
                                        <>
                                            <ButtonGroup variant="contained" sx={{
                                                visibility: {
                                                    lg: 'visible',
                                                    xs: 'hidden'
                                                },
                                            }}>
                                                <Button className="Nav-Bar-Button" component={Link} to={'/Matchmaking'} sx={styles.mySpectresLarge}>
                                                    <Typography sx={styles.buttonText}>{t('navBar.navigationButtons.mySpectres')}</Typography>
                                                </Button>
                                                <Button
                                                    className="Nav-Bar-Button"
                                                    variant="contained"
                                                    onClick={handleClick}
                                                    sx={{ mr: 1, p: 0 }}
                                                >
                                                    <ExpandMore sx={{ transform: open ? 'rotate(180deg)' : 'rotate(0deg)', transition: 'transform 0.3s' }} />
                                                </Button>
                                            </ButtonGroup>
                                            <Menu
                                                anchorEl={anchorEl}
                                                open={open}
                                                onClose={handleClose}
                                            >
                                                <MenuItem
                                                    disabled={!!isRefreshingMatchmaking}
                                                    onClick={async () => {
                                                        if (typeof refreshMatchmaking === 'function') {
                                                            try { await refreshMatchmaking(); } catch { }
                                                        }
                                                    }}
                                                >
                                                    <ListItemIcon>
                                                        <RefreshIcon fontSize="small" />
                                                    </ListItemIcon>
                                                    {t('navBar.navigationButtons.refreshList')}
                                                    {isRefreshingMatchmaking && (
                                                        <CircularProgress size={16} sx={{ ml: 1 }} />
                                                    )}
                                                </MenuItem>
                                                <Divider />
                                                {sortedOnlineMachines
                                                    .map((machine: Machine, index: number) => {
                                                        return (
                                                            <MenuItem
                                                                key={index}
                                                                component={machine.isOutdated ? 'div' : Link}
                                                                to={machine.isOutdated ? undefined : `/matchmaking/control/${encodeURIComponent(machine.machineName)}`}
                                                                onClick={() => {
                                                                    if (machine.isOutdated) {
                                                                        alert(`${machine.machineName} requires an update to version ${UPDATE_REQUIRED} or newer.`);
                                                                        return;
                                                                    }
                                                                    if (onlineMachines[index]?.connection?.ping) {
                                                                        onlineMachines[index].connection.ping()
                                                                            .then((response: boolean) => {
                                                                                if (!response) {
                                                                                    alert(`Failed to connect to ${onlineMachines[index].machineName}, please refresh the list and try again.`);
                                                                                } else {
                                                                                    setSettingsLoaded(false);
                                                                                    setSelectedMachine(machine);
                                                                                    setMachineEvents([]);
                                                                                }
                                                                            })
                                                                            .catch((err: any) => {
                                                                                console.error("Error pinging machine:", err);
                                                                                alert(`Failed to connect to ${onlineMachines[index].machineName}, please refresh the list and try again.`);
                                                                            });
                                                                    } else {
                                                                        alert(`Connection not available for ${onlineMachines[index]?.machineName || 'this machine'}, please try refreshing the machine list.`);
                                                                    }

                                                                    handleClose()
                                                                }}
                                                                sx={{
                                                                    opacity: (machine.isOutdated || machine.machineName === selectedMachine?.machineName) ? 0.5 : 1,
                                                                    cursor: (machine.isOutdated || machine.machineName === selectedMachine?.machineName) ? 'not-allowed' : 'pointer'
                                                                }}
                                                                disabled={machine.isOutdated || machine.machineName === selectedMachine?.machineName}
                                                            >
                                                                {machine.machineName}{machine.isOutdated ? ' (Update Required)' : ''}
                                                            </MenuItem>
                                                        );
                                                    })}
                                            </Menu>
                                        </>
                                        :
                                        ""
                                }
                            </Grid>

                            <Grid container item md={6}
                                direction="row"
                                justifyContent="space-between"
                                alignItems="center"
                                sx={{
                                    display: {
                                        lg: 'flex',
                                        xs: 'none'
                                    }
                                }}
                            >
                                <Grid container item md={2}
                                    sx={{
                                        display: {
                                            lg: 'block',
                                            xs: 'none'
                                        }
                                    }}>
                                    <Stack alignItems="center" direction="row" gap={1} sx={{ width: '400px' }}>
                                        {selectedMachine ?
                                            <>
                                                <Divider orientation="vertical" flexItem sx={{ backgroundColor: 'white' }} />
                                                <Typography sx={styles.buttonText} noWrap> {selectedMachine.machineName} </Typography>
                                            </>
                                            :
                                            <></>
                                        }
                                    </Stack>
                                </Grid>
                                <Grid container item md={10}
                                    direction="row"
                                    justifyContent="flex-end"
                                    alignItems="center"
                                    sx={{
                                        display: {
                                            lg: 'flex',
                                            xs: 'none'
                                        },
                                    }}
                                    gap={0.5}>
                                    {selectedMachine ?
                                        <>
                                            <Button className='Nav-Bar-Button' onClick={() => { setShowCalibration(true) }}>
                                                <Box
                                                    component="img"
                                                    sx={styles.buttonIconsNavBar}
                                                    alt="Calibrate icon"
                                                    src={Calibrate_Icon}
                                                />{t('navBar.navigationButtons.calibrate')}</Button>
                                            <Button className='Nav-Bar-Button' onClick={() => { setShowSupport(true) }}>
                                                <Box
                                                    component="img"
                                                    sx={styles.buttonIconsNavBar}
                                                    alt="Support icon"
                                                    src={Support_Icon}
                                                />{t('navBar.navigationButtons.support')}</Button>
                                            <Button className='Nav-Bar-Button' onClick={() => { setShowMachineSettings(true) }}>
                                                <Box
                                                    component="img"
                                                    sx={styles.buttonIconsNavBar}
                                                    alt="Settings icon"
                                                    src={Settings_Icon}
                                                />{t('navBar.navigationButtons.settings')}</Button>
                                            <Button className='Nav-Bar-Button' onClick={() => { setShowCertification(true) }}>
                                                <Box
                                                    component="img"
                                                    sx={styles.buttonIconsNavBar}
                                                    alt="Info icon"
                                                    src={Info_Icon}
                                                />{t('navBar.navigationButtons.machineInfo')}</Button>
                                        </>
                                        : ""}
                                    {/* <LanguageSwitcher /> */}
                                    <Box sx={{ flexGrow: 0 }}>
                                        {userIcon}
                                    </Box>
                                </Grid>
                            </Grid>
                            <Grid container item
                                direction="row"
                                justifyContent="flex-end"
                                alignItems="center"
                                sx={{
                                    display: {
                                        lg: 'none',
                                        xs: 'flex'
                                    },
                                }}
                                sm={6} xs={6}>
                                <Grid item>
                                    <IconButton
                                        color="inherit"
                                        aria-label="open drawer"
                                        edge="end"
                                        onClick={handleDrawerToggle}
                                        sx={{ color: "#FFFFFF" }}
                                    >
                                        <MenuIcon />
                                    </IconButton>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Toolbar>
                </Container>
            </AppBar>
            <nav>
                <Drawer
                    container={container}
                    variant="temporary"
                    open={mobileNavbarOpen}
                    onClose={handleDrawerToggle}
                    ModalProps={{
                        keepMounted: true, // Better open performance on mobile.
                    }}
                    sx={{
                        display: { md: 'block', lg: 'none' },
                        '& .MuiDrawer-paper': {
                            boxSizing: 'border-box',
                            width: drawerWidth,
                            height: '100%',
                            backgroundColor: styles.drawer.backgroundColor,
                            overflowY: 'auto' // Allow scrolling when content exceeds viewport height
                        },
                        zIndex: 1250
                    }}
                    anchor='right'
                >
                    {drawer}
                </Drawer>
            </nav>
        </>
    )
}